import { render } from "./EventTiktok.vue?vue&type=template&id=58eabf25"
import script from "./EventTiktok.vue?vue&type=script&lang=js"
export * from "./EventTiktok.vue?vue&type=script&lang=js"

import "./EventTiktok.vue?vue&type=style&index=0&id=58eabf25&lang=scss&scope=true"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__